export function encodeToBase64(string) {
  return _bytesToBase64(new TextEncoder().encode(string))
}

export function decodeToBase64(string) {
  return new TextDecoder().decode(_base64ToBytes(string))
}

function _base64ToBytes(base64) {
  const binString = atob(base64)
  return Uint8Array.from(binString, (m) => m.codePointAt(0))
}

function _bytesToBase64(bytes) {
  const binString = Array.from(bytes, (byte) =>
    String.fromCodePoint(byte)
  ).join('')
  return btoa(binString)
}
